<template>
  <v-container>
    <v-card>
      <v-toolbar
        dark
        color="primary"
      >
        <v-toolbar-title>Cadastro de recurso</v-toolbar-title>
      </v-toolbar>


      <v-card-text >
        <v-progress-linear color="secondary"  :indeterminate="true" v-if="loading">
        </v-progress-linear>

        <v-form
          ref="form_recurso"
          v-model="valid"
          lazy-validation
          v-else
        >
          <v-layout class="mt-1">
            <v-flex
              xs12
              sm6
            >
            <v-radio-group
              v-model="recursoInscricao.co_fase"
              row
              :rules="[rules.required]"
              >
                <v-radio
                  label="Conselho de cultura"
                  :value="recursoInscricao.co_fase"
                  :disabled="true"
                  v-if="recursoInscricao.co_fase == codigosFase.RECURSO_INSCRICOES_CONSELHO"
                />
                <v-radio
                  label="Organização ou entidade cultural"
                  :value="recursoInscricao.co_fase"
                  :disabled="true"
                  v-if="recursoInscricao.co_fase == codigosFase.RECURSO_INSCRICOES_ORGANIZACAO"
                />
              </v-radio-group>
            </v-flex>
          </v-layout>
          <v-layout
            wrap
            align-center
            class="mt-1"
          >
            <v-flex
              xs12
              sm6
            >
              <v-text-field
                v-model="entidade.nu_cnpj"
                label="*CNPJ"
                append-icon="people"
                :disabled="true"
                placeholder="99.999.999/9999-99"
                :error-messages="nomeConselhoError"
                mask="##.###.###/####-##"
                :rules="[rules.required, rules.cnpjMin]"
                required
              />
            </v-flex>
            <v-flex
              xs12
              sm6
            >
              <v-text-field
                v-model="entidade.no_razao_social"
                label="Razão social"
                append-icon="people_outline"
                :disabled="true"
                :rules="[rules.cnpjInvalido]"
                required
                style="margin-left: 20px"
              />
            </v-flex>
          </v-layout>
          <v-layout
            wrap
            align-center
            class="mt-1"
          >
            <v-flex
              xs12
              sm6
            >
              <v-text-field
                v-model="recursoInscricao.representante.nu_cpf"
                label="*CPF do representante"
                append-icon="person"
                :disabled="true"
                placeholder="999.999.999-99"
                mask="###.###.###-##"
                :error-messages="nomeRepresentanteError"
                :rules="[rules.required, rules.cpfMin]"
                required
              />
            </v-flex>
            <v-flex
              xs12
              sm6
            >
              <v-text-field
                v-model="recursoInscricao.representante.no_nome"
                :disabled="true"
                label="*Nome do representante"
                append-icon="perm_identity"
                :error-messages="nomeRepresentanteError"
                :rules="[rules.cpfInvalido]"
                style="margin-left: 20px"
                required
              />
            </v-flex>
          </v-layout>

          <v-layout
            wrap
            align-center
            class="mt-1"
          >
            <v-flex
              xs12
              sm6
            >
              <v-text-field
                v-model="recursoInscricao.representante.ds_email"
                data-vv-name="email"
                label="*E-mail do representante"
                append-icon="mail"
                :disabled="true"
                placeholder="email@exemplo.com"
                counter
                maxlength="100"
                :rules="[rules.required, rules.email]"
                required
                hint="Atenção: este e-mail deverá ser acessado para acompanhamento do recurso"
                persistent-hint
              />
            </v-flex>
            <v-flex
              xs12
              sm6
            >
              <v-text-field
                v-model="recursoInscricao.representante.nu_telefone"
                label="*Celular do representante"
                append-icon="phone"
                :disabled="true"
                placeholder="(99) 99999-9999"
                mask="(##) #####-####"
                :rules="[rules.required, rules.phoneMin]"
                required
                style="margin-left: 20px"
              />
            </v-flex>
          </v-layout>
          <v-layout v-if="!isLocked">
            <v-flex xs12 lg2 md4 sm4>
              <v-card class="mt-4 ml-4">
                <v-card-text class="recurso-inscricao-file">
                  <file
                    v-model="recurso_inscricao"
                    max-file-size="100MB"
                    max-files="1"
                    label-idle="Clique aqui para anexar um arquivo (PDF ou JPEG com limite de 100 MB)"
                    :accepted-file-types="acceptedFileTypes"
                    :readonly="isLocked"
                    :disabled="isLocked"
                    @input="fileAdded()"
                  />
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout
            wrap
            align-center
          >
            <v-flex
              xs12
              sm12
            >
              <div class="ma-4 text-justify subheading grey--text">
                Ao Departamento do Sistema Nacional de Cultura,
                da Secretaria Nacional da Economia Criativa e Diversidade Cultural,
                conforme <a href="http://cnpc.cultura.gov.br/edital-de-selecao-publica-dos-representantes-sociedade-civil-mandato-20222025/" target="_blank">item 6 do edital de Chamada Pública</a> para
                seleção dos representantes da sociedade civil para compor o Conselho
                Nacional de Política Cultural (CNPC) - no triênio 2022/2025, venho interpor
                recurso em face do resultado na etapa de inscrição pelos motivos abaixo descritos:
              </div>
            </v-flex>
          </v-layout>
          <v-layout
            wrap
            align-center
          >
            <v-flex
              xs12
              sm12
              class="ma-3"
            >
              <v-textarea
                v-model="recursoInscricao.ds_recurso"
                name="input-7-1"
                box
                solo
                label="Descrição do recurso"
                auto-grow
                :placeholder="'Digite seu recurso aqui.'"
                :counter="3000"
                :rules="[rules.required, rules.tamanhoMaximoCaracteres]"
                :readonly="isLocked"
                :disabled="isLocked"
              />
            </v-flex>

             <v-flex
              xs12
              sm12
              class="ma-3"
            >
            <v-card 
              class="mt-2" 
              v-if="recursoInscricao.st_parecer_validado"
            >
              <v-card-text>
                <v-layout
                  wrap
                  align-center
                >
                  <v-flex
                    xs12
                    sm12
                    class="ma-3"
                  >
                    <div class="ma-4 text-justify subheading grey--text">
                      <b>Resultado da Avaliação do Recurso:</b>
                    </div>
                    <v-textarea
                      v-model="recursoInscricao.ds_parecer"
                      name="input-7-1"
                      box
                      solo
                      label="Parecer do recurso"
                      auto-grow
                      :disabled="true"
                      :readOnly="true"
                    />
                  </v-flex>
                </v-layout>
                <v-flex sm12 v-if="recursoInscricao.arquivos && !recursoInscricao.arquivos.find(a => a.tp_arquivo == 'parecer_recurso_inscricao')">
                    <v-btn
                      color="blue-grey"
                      class="white--text text-capitalize"
                      @click="downloadArquivo(recursoInscricao.arquivos.find(a => a.tp_arquivo == 'parecer_recurso_inscricao').co_arquivo)"
                      outline
                    >
                      Download anexo
                      <v-icon right dark>cloud_download</v-icon>
                    </v-btn>
                  </v-flex>

                  <v-flex
              xs12
              sm6
            >
            <v-radio-group
              v-model="recursoInscricao.st_parecer"
              row
              >
                <v-radio
                  label="Recurso Deferido"
                  :value="recursoInscricao.st_parecer"
                  :disabled="true"
                  :readonly="true"
                  v-if="recursoInscricao.st_parecer == 1"
                >
                <template v-slot:label>
                    <div><strong class="success--text">Recurso Deferido</strong></div>
                  </template>
                </v-radio>
                <v-radio
                  label="Recurso Indeferido"
                  :value="recursoInscricao.st_parecer"
                  :disabled="true"
                  :readonly="true"
                  v-if="recursoInscricao.co_fase == 0"
                >
                <template v-slot:label>
                    <div><strong class="error--text">Recurso Indeferido</strong></div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-flex>
              </v-card-text>
            </v-card>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
      <v-layout
        v-if="!isLocked"
        wrap
        align-center
      >
        <v-flex offset-xs5>
          <v-btn to="/">
            Cancelar
          </v-btn>
          <v-btn
            :disabled="!valid"
            :readonly="!isLocked"
            color="primary"
            @click="abrirDialogo"
          >
            Enviar
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card>

    <v-layout justify-center>
      <dialog-confirmacao
        v-model="dialog"
        title="Deseja realmente enviar?"
        text="Os dados enviados não poderão ser alterados posteriormente."
        cancel-text="Não"
        confirmText="Sim"
        @dialog-response="respostaDialog"
        :isLoading="loading"
      />
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import File from '@/core/components/upload/File';
import Validate from '../../shared/util/validate';
import codigosPerfil from '../../conta/utils/codigosPerfil';
import codigosFase from '../../fase/utils/codigosFase';
import DialogConfirmacao from '../../shared/components/DialogConfirmacao';

export default {
  components: { 
    File,
    DialogConfirmacao,
  },
  data: () => ({
    codigosFase,
    dialog: false,
    valid: false,
    nomeConselho: '',
    nomeConselhoError: '',
    nomeRepresentante: '',
    nomeRepresentanteError: '',
    isUsuarioPermitido: false,
    usuarioLogado: {},
    perfilUsuario: {},
    entidade: {
      nu_cnpj: '',
      no_razao_social: '',
      sg_uf: '',
    },
    loading: true,
    recursoInscricao: {
      co_fase: '',
      ds_email: '',
      nu_cnpj: '',
      nu_cpf: '',
      nu_telefone: '',
      ds_recurso: '',
      no_razao_social: '',
      no_representante: '',
      anexos: [],
      representante: {
        ds_email: '',
        no_nome: '',
        nu_rg: '',
        nu_cpf: '',
        nu_telefone: '',
        ds_email_confirmation: '',
        endereco: {
          co_ibge: '',
          ds_complemento: '',
          nu_cep: '',
          ds_logradouro: '',
          co_municipio: '',
          no_bairro: ''
        },
      },
      st_parecer_validado: false,
    },
    listaRecursos: [
      {
        co_fase: codigosFase.RECURSO_INSCRICOES_CONSELHO,
        tp_fase: 'recurso_inscricoes_conselho',
        ds_detalhamento: 'Conselho',
        co_perfil: codigosPerfil.CODIGO_CONSELHO,
      },
      {
        co_fase: codigosFase.RECURSO_INSCRICOES_ORGANIZACAO,
        tp_fase: 'recurso_inscricoes_organizacao',
        ds_detalhamento: 'Organização',
        co_perfil: codigosPerfil.CODIGO_ORGANIZACAO,
      },
    ],
    isLocked: false,
    fileLoaded: false,
    recurso_inscricao: {},
    acceptedFileTypes: [
      'image/jpeg',
      'application/pdf',
    ],
    rules: {
      required: value => !!value || 'Campo não preenchido',
      cnpjInvalido: value => !!value || 'CNPJ não encontrado',
      cpfInvalido: value => !!value || 'CPF não encontrado',
      phoneMin: value => (value && value.length >= 9) || 'Mínimo de 9 caracteres',
      cnpjMin: value => (value && value.length === 14) || 'Mínimo de 14 caracteres',
      cpfMin: value => (value && value.length === 11) || 'Mínimo de 11 caracteres',
      email: (value) => {
        // eslint-disable-next-line
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'E-mail invalido';
      },
      tamanhoMaximoCaracteres: value => (!!value && value.length <= 3000) || 'Máximo 3000 caracteres',
    },
  }),
  watch: {
    'recursoInscricao.nu_cnpj': function (value) {
      const self = this;
      self.nomeConselho = '';
      this.nomeConselhoError = 'CNPJ inválido';
      if (value.length === 14 && Validate.isCnpjValido(value)) {
        this.consultarCNPJ(value).then((response) => {
          const { data } = response.data;
          self.nomeConselho = data.nmRazaoSocial;
        });
        this.nomeConselhoError = '';
      }
    },
    'recursoInscricao.nu_cpf': function (value) {
      const self = this;
      self.nomeRepresentante = '';
      this.nomeRepresentanteError = 'CPF inválido';
      if (value.length === 11 && Validate.isCpfValido(value)) {
        this.consultarCPF(value).then((response) => {
          const { data } = response.data;
          self.nomeRepresentante = data.nmPessoaFisica;
        });
        this.nomeRepresentanteError = '';
      }
    },
    fases() {
      this.checkRecursoIsncricao();
    },
    perfilUsuario() {
      if(this.isUsuarioPermitido){
        this.recursoInscricao.co_fase = this.listaRecursos.find(r => r.co_perfil == this.perfilUsuario.co_perfil).co_fase;
      }
    },
    usuarioLogado() {
      if(this.isUsuarioPermitido){
        this.obterRepresentanteLogado(this.usuarioLogado.nu_cpf);
      }
    },
    representante() {
      if (this.representante.recursoInscricao) {
        this.recursoInscricao = this.representante.recursoInscricao;
        this.isLocked = true;
      }
      this.recursoInscricao.representante = this.representante;
      this.handleEntidade();
    },
    conselho() {
      this.entidade.nu_cnpj = this.conselho.nu_cnpj;
      this.entidade.no_razao_social = this.conselho.no_conselho;
      this.entidade.sg_uf = this.conselho.endereco.municipio.uf.sg_uf;
      this.loading = false;
    },
    organizacao() {
      this.entidade.nu_cnpj = this.organizacao.nu_cnpj;
      this.entidade.no_razao_social = this.organizacao.no_organizacao;
      this.entidade.sg_uf = this.organizacao.endereco.municipio.uf.sg_uf;
      this.loading = false;
    },
  },
  computed: {
    ...mapGetters({
        ativarRecursoInscricaoConselho: 'fase/ativarRecursoInscricaoConselho',
        ativarRecursoInscricaoOrganizacao: 'fase/ativarRecursoInscricaoOrganizacao',
        fases: 'fase/fases',
        usuario: 'conta/usuario',
        perfil: 'conta/perfil',
        representante: 'representante/representanteUsuarioLogado',
        organizacao: 'organizacao/organizacaoUsuarioLogado',
        conselho: 'conselho/conselhoUsuarioLogado',
    }),
  },
  methods: {
    ...mapActions({
      consultarCNPJ: 'pessoa/consultarCNPJ',
      consultarCPF: 'pessoa/consultarCPF',
      definirMensagemSucesso: 'app/setMensagemSucesso',
      definirMensagemErro: 'app/setMensagemErro',
      enviarDadosRecursoInscricao: 'recurso/enviarDadosRecursoInscricao',
      obterRepresentanteLogado: 'representante/obterRepresentantePorCPF',
      obterOrganizacaoPorRepresentante: 'organizacao/obterOrganizacaoPorRepresentante',
      obterConselhoPorRepresentante: 'conselho/obterConselhoPorRepresentante',
      
    }),
    validarIrProximaEtapa(formRef) {
      if (this.$refs[formRef].validate()) {
        this.etapaFormulario = this.etapaFormulario + 1;
      }
    },
    respostaDialog(tipoResposta){
      if(tipoResposta){
        this.salvar();
      }else{
        this.fecharDialogo()
      }
    },
    salvar() {
      this.validarAnexos();
      this.loading = true;
      this.recursoInscricao.no_razao_social       = this.entidade.no_razao_social;
      this.recursoInscricao.nu_cnpj               = this.entidade.nu_cnpj;
      this.recursoInscricao.sg_uf                 = this.entidade.sg_uf;
      this.recursoInscricao.no_representante      = this.representante.no_nome;
      this.recursoInscricao.nu_cpf                = this.representante.nu_cpf;
      this.recursoInscricao.ds_email              = this.representante.ds_email;
      this.recursoInscricao.nu_telefone           = this.representante.nu_telefone;

      this.enviarDadosRecursoInscricao(this.recursoInscricao)
        .then((response) => {
          this.definirMensagemSucesso(response.data.message);
          this.$router.push('/');
        }).finally(() => {
          this.loading = false;
          this.fecharDialogo();
        });
    },
    validarAnexos() {
      this.recursoInscricao.anexos = [];
      const anexos = [
        'recurso_inscricao',
      ];

      anexos.forEach((nomeAnexo) => {
        if (
          nomeAnexo === 'recurso_inscricao'
          && Object.values(this[nomeAnexo]).length === 0)
        {
          return;
        }

        this.recursoInscricao.anexos.push({
          tp_arquivo: nomeAnexo,
          no_extensao: this[nomeAnexo].fileExtension,
          no_mime_type: this[nomeAnexo].fileType,
          no_arquivo: this[nomeAnexo].filename,
          arquivoCodificado: this[nomeAnexo].getFileEncodeBase64String(),
        });
      });
    },
    abrirDialogo() {
      if (!this.$refs.form_recurso.validate()) {
        return false;
      }
      this.dialog = true;
      return true;
    },
    fecharDialogo() {
      this.dialog = false;
    },
    checkRecursoIsncricao() {
      if (!this.isActiveRecursoInscricao()) {
        this.definirMensagemErro('O prazo de recurso da inscrição expirou!');
        this.$router.push('/').catch(()=>{});
      }
    },
    checkUsuario(){
        if(!this.isUsuarioPermitido) {
            this.definirMensagemErro('Conselho de Cultura, Organização ou Entidade Cultural não associada ao perfil');
            this.$router.push('/').catch(()=>{});
        }      
        return true;
    },
    isActiveRecursoInscricao() {
      let faseRecursoInscricao = {};
      if(this.perfil.no_perfil == 'conselho'){
        faseRecursoInscricao = this.fases.find(f => f.tp_fase == codigosFase.TP_RECURSO_INSCRICOES_CONSELHO);
      } else {
        faseRecursoInscricao = this.fases.find(f => f.tp_fase == codigosFase.TP_RECURSO_INSCRICOES_ORGANIZACAO);
      }
      const dataInicio = moment(faseRecursoInscricao.dh_inicio).toDate().getTime();
      const dataAtual = moment().toDate().getTime();

      return dataAtual >= dataInicio;
    },
    fileAdded(value) {
      this.fileLoaded = !this.fileLoaded;
    },
    handleEntidade(){
      if(this.perfilUsuario.co_perfil == 3){
        this.obterConselhoPorRepresentante(this.representante.co_representante);
      } else{
        this.obterOrganizacaoPorRepresentante(this.representante.co_representante);
      }
    },
  },
  mounted() {
    this.isUsuarioPermitido = (this.perfil.no_perfil == 'conselho' || this.perfil.no_perfil == 'organizacao');
    if (this.fases && this.fases.length > 0) {
      this.checkRecursoIsncricao();
    }

    this.checkUsuario();

    this.usuarioLogado = this.usuario;
    this.perfilUsuario = this.perfil;
  },
};
</script>

<style>
  .recurso-inscricao-file
  .filepond--drop-label {
    font-size: 0.86rem;
  }
</style>
